import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
export interface Toast {
  type: ToastType;
  message: string;
  id?: number;
  delay?: number;
  show?: boolean;
}

export enum ToastType {
  INFO = 'info',
  ERROR = 'error' ,
  WARNING = 'warning' ,
  SUCCESS = 'success'
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts: Toast[] = [];

  defaultDelay = 6000;

  private toastsSubject = new BehaviorSubject<Toast[]>([]);
  toasts$ = this.toastsSubject.asObservable();

  fire(toast: Toast) {
    const id = this.toasts.length;
    const toastWithMeta: Toast = { ...toast, id, show: false };
    this.toasts.push(toastWithMeta);
    this.toastsSubject.next([...this.toasts]);

    setTimeout(() => {
      toastWithMeta.show = true;
      this.toastsSubject.next([...this.toasts]);
    }, 100);

    setTimeout(() => {
      this.dismiss(id);
    }, toast.delay ?? this.defaultDelay);
  }

  dismiss(id: Toast['id']) {
    const toast = this.toasts.find((t) => t.id === id);
    if (toast) {
      toast.show = false;
      this.toastsSubject.next([...this.toasts]);
      setTimeout(() => {
        this.toasts = this.toasts.filter((t: Toast) => t.id !== id);
        this.toastsSubject.next([...this.toasts]);
      }, 300);
    }
  }
}
